module.exports = __webpack_public_path__ + "3b8120c84196d64710b40fc0cc582b43.svg";